const items = [
    /*
    {
        name: 'Locations',
        link: '/locations',
        icon: ' fa fa-building'
    },
    */
    {
        name: 'Nodes',
        link: '/nodes',
        icon: ' fa fa-bolt'
    },
    {
        name: 'Purchase Labels',
        link: '/purchase',
        icon: ' fa fa-shopping-cart'
    },
    {
        name: 'Order History',
        link: '/orders',
        icon: ' fa fa-search-dollar'
    },
];
export default items;
